import {Validators, UntypedFormBuilder,  UntypedFormGroup, ReactiveFormsModule} from '@angular/forms';
import {ClientStatusService} from '../../status/client-status.service';
import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { LocalSecurityService } from '../../../services/shared/local-security.service';
import { NgClass } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormField, MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { MatInput } from '@angular/material/input';




@Component({
    selector: 'app-update-maintenance',
    standalone: true,
    templateUrl: './update-maintenance.component.html',
    styleUrls: ['./update-maintenance.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass, MatCheckboxModule, MatLabel, MatFormField, MatCardModule, MatFormFieldModule, MatInput, ReactiveFormsModule]
})
export class UpdateMaintenanceComponent implements OnInit {
  private localSecuritySvc = inject(LocalSecurityService);
  private clientStatusSvc = inject(ClientStatusService);
  private formBuilder = inject(UntypedFormBuilder);


  userPassword: string;
  passInputType: string = 'password';
  savestatus: string = '';
  isPasswordSet: boolean = false;
  inprogress: boolean = false;

  passwordForm: UntypedFormGroup;

  constructor() {
      this.validatePassword();
     }

  ngOnInit() {
    this.checkPasswordSet();
  }

  get pForm() { return this.passwordForm.controls; }

  togglePasswordText() {
    this.passInputType = this.passInputType === 'password' ? 'text' : 'password';
  }

  validatePassword=()=>{
    this.passwordForm = this.formBuilder.group({
      password: [
        '', 
        [
          Validators.required,
          Validators.minLength(8), 
          Validators.maxLength(127),
          Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[()`:[";.\'{=,}<|>_+~#?!@$%^&*-])[A-Za-z0-9()`:[";.\'{=,}<|>_+~#?!@$%^&*-].*$')
        ]
      ]
    });
  }

  registerPassword=()=>{
    this.savestatus = null;
    this.inprogress = true;

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    this.localSecuritySvc.register({password: this.passwordForm.get('password').value}).subscribe( data =>{
      this.savestatus = 'Success';
      this.inprogress = false;
      this.isPasswordSet = true;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    }, err =>{
      this.savestatus = 'Failed.';
      this.inprogress = false;
    });   
  }

  checkPasswordSet=()=>{
    const data = {
      username: sessionStorage.getItem('ngStorage-ecausername')
    }
    this.clientStatusSvc.doPost('user', data).subscribe((data: any)=>{
      if(data.password){
        this.isPasswordSet = data.password;
      }else{
        this.isPasswordSet = false;
      }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    },error=>{
      this.isPasswordSet = false;
    });
  }

  getErrors=(errors)=>{
    return JSON.stringify(errors);
  }

}
